import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'insurance-packages-diagnoses-count-badge',
  standalone: true,
  imports: [MatIcon, TranslatePipe],
  templateUrl: './diagnoses-count-badge.component.html',
  host: { class: 'inline-flex w-fit shrink-0 items-center gap-1 rounded-full border border-purple-200 bg-purple-100 px-2 py-0.5 text-[11px] font-bold text-purple-600' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosesCountBadgeComponent {
  readonly count = input.required<number>();
  readonly showIcon = input<boolean>(true);
}
